export const version = "rlp/5.7.0";
//# sourceMappingURL=_version.js.map